export default "__VITE_PUBLIC_ASSET__fe85df70__"